// KaziPeople's OWN payment collection (direct Vodacom M-Pesa C2B into the
// KaziPeople business shortcode) — billing-service via the gateway.
// The API never returns a secret: the API key is write-only; status carries
// presence flags + a short fingerprint only.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const C = `${API_V1}/billing/admin/collection-config/mpesa`;

export interface CollectionStatus {
  provider: 'mpesa';
  wallet_provider: 'mpesa' | 'azampay';
  bank_provider: 'azampay' | 'none';
  source: 'db' | 'env' | 'none';
  enabled: boolean;
  available: boolean;
  unavailable_reason: string | null;
  environment: 'sandbox' | 'live' | null;
  active_version: number | null;
  service_provider_code: string | null;
  api_key_set: boolean;
  api_key_fingerprint: string | null;
  public_key_valid: boolean;
  items_desc: string | null;
  kek_configured: boolean;
  live_allowed: boolean;
  last_test: { at: string; ok: boolean | null; message: string | null; version: number | null } | null;
  versions: Array<{ version: number; environment: string; service_provider_code: string; created_at: string; created_by: string | null }>;
}

export interface CollectionAuditRow {
  id: string;
  action: string;
  actorId: string | null;
  actorEmail: string | null;
  details: Record<string, unknown>;
  createdAt: string;
}

export interface SaveCredentialsBody {
  environment: 'sandbox' | 'live';
  apiKey?: string;
  publicKey?: string;
  serviceProviderCode?: string;
  itemsDesc?: string;
  confirmLive?: string;
  reason?: string;
}

export const getCollectionStatus = () => axios.get<CollectionStatus>(C).then((r) => r.data);
export const getCollectionAudit = () => axios.get<CollectionAuditRow[]>(`${C}/audit`).then((r) => r.data);
export const saveCredentials = (body: SaveCredentialsBody) =>
  axios.put<CollectionStatus>(`${C}/credentials`, body).then((r) => r.data);
export const switchEnvironment = (body: SaveCredentialsBody) =>
  axios.post<CollectionStatus>(`${C}/environment`, body).then((r) => r.data);
export const setCollectionEnabled = (enabled: boolean, reason?: string) =>
  axios.post<CollectionStatus>(`${C}/enabled`, { enabled, reason }).then((r) => r.data);
export const testConnection = () =>
  axios.post<{ ok: boolean; message: string; status: CollectionStatus }>(`${C}/test`).then((r) => r.data);

/** The service's own words for a refusal (it explains every one). */
export function apiErrorMessage(e: unknown, fallback: string): string {
  const d = (e as any)?.response?.data;
  const m = d?.message ?? d?.error ?? d?.detail;
  if (Array.isArray(m) && m.length) return String(m[0]);
  if (typeof m === 'string' && m.trim()) return m;
  return fallback;
}
